<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Poppins', 'Poppins Fallback', sans-serif;
  background-color: #fcfcfc;
}

#app {
  min-height: 100vh;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  width: 100%;
}
.container1200{
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  width: 100%;
}

.el-button:hover,
.el-button:focus {
  background-color: #ff1a2a;
  border-color: #ff1a2a;
  color: #ffffff;
}

.el-button:active {
  background-color: #cc0010;
  border-color: #cc0010;
  color: #ffffff;
}

.el-button--main {
  background-color: #e60013 !important;
  border-color: #e60013 !important;
  color: #ffffff !important;
}

.el-button--main:hover,
.el-button--main:focus,
.el-button--main:active{
  background-color: #e60013 !important;
  border-color: #e60013 !important;
  color: #ffffff !important;
}
.pt80{
  padding-top: 80px;
}

.el-breadcrumb{
  margin-bottom: 30px;
}

.text-center {
  text-align: center;
}

.mb-20 {
  margin-bottom: 20px;
}

.mt-20 {
  margin-top: 20px;
}
</style>
